import { useNavigate } from 'react-router-dom'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getDiagnoses } from '@/infra/api/generated/diagnoses/diagnoses'
import { StartDiagnosisRequest, FamilyDto } from '@/infra/api/generated/model'
import { START_DIAGNOSIS_SOURCE, trackEvent } from '@/src/analytics/amplitude'

const { startDiagnosis } = getDiagnoses()

export const useStartDiagnosis = () => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (request: StartDiagnosisRequest) => startDiagnosis(request),
    onSuccess: async (result) => {
      await queryClient.invalidateQueries({ queryKey: ['diagnoses'] })
      void navigate(`/diagnoses/${result.diagnosisId}/questions`)
    },
    onError: (error) => {
      console.error('Error while starting diagnosis:', error)
    },
  })

  const handleStart = (
    family: FamilyDto,
    storeId: number,
    teamId: number,
    source: START_DIAGNOSIS_SOURCE
  ) => {
    mutation.mutate(
      { familyId: family.id, storeId, teamId },
      {
        onSuccess: (result) => {
          if (result.isNewlyCreated) {
            trackEvent('START_DIAGNOSIS', {
              familyId: family.id,
              isPriorityFamily: family.isPriority,
              diagnosisId: result.diagnosisId,
              source,
            })
          }
        },
      }
    )
  }

  return {
    startDiagnosis: handleStart,
    isPending: mutation.isPending,
    error: mutation.error,
  }
}
